import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const statusClasses = {
  info: "border-sky-400/25 bg-sky-500/10 text-sky-700 dark:text-sky-200",
  safe: "border-emerald-400/25 bg-emerald-500/10 text-emerald-700 dark:text-emerald-200",
  caution: "border-yellow-400/30 bg-yellow-500/10 text-yellow-700 dark:text-yellow-200",
  warning: "border-orange-400/30 bg-orange-500/10 text-orange-700 dark:text-orange-200",
  danger: "border-red-400/30 bg-red-500/10 text-red-700 dark:text-red-200",
};

export default function WorkflowStatusCard({ icon: Icon, title, status = "info", aiSummary, primaryValue, details, actionLabel, actionHref }) {
  const action = actionLabel && actionHref;
  return (
    <article className={cn("rounded-2xl border p-4", statusClasses[status] || statusClasses.info)}>
      <div className="flex items-start gap-3">
        {Icon && <Icon className="mt-0.5 h-5 w-5 shrink-0 text-current" aria-hidden="true" />}
        <div className="min-w-0 flex-1">
          <h4 className="text-xs font-black uppercase tracking-wide text-current">{title}</h4>
          {primaryValue && <p className="mt-1 text-sm font-black leading-6 text-foreground">{primaryValue}</p>}
          {aiSummary && <p className="mt-1 text-sm font-semibold leading-6 text-muted-foreground">{aiSummary}</p>}
          {details && <p className="mt-2 text-xs leading-5 text-muted-foreground">{details}</p>}
          {action && <Link to={actionHref} className="mt-3 inline-flex items-center gap-1 text-xs font-black text-primary">{actionLabel}<ArrowRight className="h-3 w-3" /></Link>}
        </div>
      </div>
    </article>
  );
}